import { dataFileSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileSolid = /*#__PURE__*/createIcon(dataFileSolid)
export default IconFileSolid
